import { ChangeDetectionStrategy, Component, Inject, Input, OnInit } from '@angular/core';
import { MatSnackBar } from '@angular/material/snack-bar';
import { constants } from 'src/app/shared/common/contants';
import { CommonService } from 'src/app/shared/services/common.service';
import { ReportingServiceService } from 'src/app/shared/services/reporting-service.service';
import { UserMultiColumnDropdownComponent } from '../../user-multi-column-dropdown/user-multi-column-dropdown.component';
import { MAT_DIALOG_DATA, MatDialog, MatDialogRef } from '@angular/material/dialog';
import { LoginService } from 'src/app/shared/services/login.service';
import { ActionCheckBox } from 'src/app/shared/common/ActionCheckBox';
import { LocalStorageSettingsService } from 'src/app/shared/services/local-storage-settings.service';
import { ReporttemplateService } from 'src/app/shared/services/reporttemplate.service';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { ErrorMessages } from 'src/app/shared/common/errormessages';
import { validationmethod } from 'src/app/shared/models/validationmethod';
import { FitersserviceService } from '../../filters/filterspopup/fitersservice.service';
import { NgxUiLoaderService } from 'ngx-ui-loader';
import * as moment from 'moment';
import { DateAdapter, MAT_DATE_FORMATS, NativeDateAdapter } from '@angular/material/core';
import { CommonPopupSearchComponent } from '../../common-popup-search/common-popup-search.component';
import { truncate } from 'fs/promises';
import { ManageVisualsService } from 'src/app/shared/services/manage-visuals.service';
import { filter,firstValueFrom,defaultIfEmpty } from 'rxjs';

export interface checkinListDialogData {
  edata: any;
  page: any;
  columns: any;
  dataSetId: any;
  objectGroup:any;
  columnsData:any;
  datasetData:any;
  showVisualDropDowns:any;
  selectedFiltersArray:any[];
  hideReportName:any;
  isChecked:any;
 // isResetChecked:any;
}
export interface ConditionalOPeratorTypeWhere {
  name: string,
  value: string
}

export class CustomDateAdapter extends NativeDateAdapter {
  override format(date: Date, displayFormat: Object): string {
    const year = date.getFullYear();
    const month = (date.getMonth() + 1).toString().padStart(2, '0');
    const day = date.getDate().toString().padStart(2, '0');

    return `${year}/${month}/${day}`;
  }
}
const MY_DATE_FORMATS = {
  parse: {
    dateInput: 'YYYY/MM/DD',
  },
  display: {
    dateInput: 'YYYY/MM/DD',
    monthYearLabel: 'YYYY MMM',
    dateA11yLabel: 'YYYY/MM/DD',
    monthYearA11yLabel: 'YYYY MMMM',
  },
};
@Component({
    selector: 'app-select-filters-pop-up',
    templateUrl: './select-filters-pop-up.component.html',
    styleUrls: ['./select-filters-pop-up.component.scss'],
    providers: [
        { provide: DateAdapter, useClass: CustomDateAdapter },
        { provide: MAT_DATE_FORMATS, useValue: MY_DATE_FORMATS },
    ],
    standalone: false
})

/*
Author->Abhishek T
Date-24-06-2024
adding select filter popup for analysis
*/

export class SelectFiltersPopUpComponent implements OnInit {
  userReportName:any='';
  selectedExternalFilterS3Path;
  selectedFilterManageId;
  isExternalFilter=false;
  allocateButtonsBoolean = false;
  allocateButtons1Boolean=true;
  formValid: FormGroup;
  selectedFilter=[];
  selectedFiltersList:any=[];
  uniqueData = []
  selectedRowData;
  selectedMultipleRowData=[];
  gridAPI;
  lastPage;
  currentPage;
  nextPage;
  nextPagePlusOne;
  totalPages;
  gridColumnAPI;
  columnDefs;
  rowData;
  rowClassRules;
  defaultColDef;
  rowSelection;
  paginationPageSize;
  paginationNumberFormatter;
  pageSize;
  components: any;
  overlayNoRowsTemplate;
  validation_messages;
  getdata: any = [];
  reportData: any;
  userid: any;
  fieldslist: any = {};

  conditionalOperatorDataWhere: ConditionalOPeratorTypeWhere[] = [
    { name: "Matches", value: "=" },
    { name: "Does Not Matches", value: "<>" },
    { name: "Matches At Least One", value: "IN" },
    { name: "Matches At Least One (Exclude)", value: "NOT IN" },
    { name: "Starts With", value: "Starts with" },
    { name: "Ends With", value: "Ends with" },
    { name: "Contains", value: "contains" },
     { name: "Contains (Exclude)", value: "Contains (Exclude)" },
    { name: "Greater Than Or Equals", value: ">=" },
    { name: "Is Greater Than", value: ">" },
    { name: "Less Than Or Equals", value: "<=" },
    { name: "Is Less Than", value: "<" },
    { name: "Between", value: "BETWEEN" },
    { name: "Space Separated", value: "Space Separated" },
    { name: "Space Separated (Exclude)", value: "Space Separated (Exclude)" },
    // { name: "MAX", value: "MAX" },
    // { name: "MIN", value: "MIN" },
    // { name: "Calculated Field", value: "CalculatedField" },
    // { name: "Calculated Field With Filter", value: "CalculatedFieldWithFilter" },
    // { name: "Calculated Field For Reports", value: "CalculatedFieldForReports" },
    // { name: "Count", value: "count"}
  ];
  backgroundColorButton = "";
  multiSelectVaules = [];
  datasetColummnData=[];
  visualTypeData=[
    {
      visualTypeName:"Tabular"
    },
    {
      visualTypeName:"Pivot"
    }
  ]
  visualType;
  visualData;
  selectedVisualId;
  visualTypeDisabled:boolean=true;
  datasetLastRefreshedDate;
  showVisualDropDowns=false;
  hideReportName=false;
  isChecked=false;
  //isResetChecked=false;
  resetClicked=false;
  selected;
  //I need to 
  userSpecificFilterData={
   
    label:"",
whereKey:"",
whereConditionValue: "",
whereValue:"",
whereValue1: ""
  }
  oldFiltersList:any;
  @Input() filters: any[] = [];
  constructor(private commonService: CommonService, private snackbar: MatSnackBar, private constants: constants, public dialogref: MatDialogRef<UserMultiColumnDropdownComponent>,
    @Inject(MAT_DIALOG_DATA) public data: checkinListDialogData, private dropdownService: ReportingServiceService,
    private errormessages: ErrorMessages,
    private validation: validationmethod,private spinner: NgxUiLoaderService,
     private loginService: LoginService, private localStorageSettings: LocalStorageSettingsService,private reportService: ReporttemplateService,private service: FitersserviceService, private dialog: MatDialog,
     private visualServices:ManageVisualsService,private snackBar: MatSnackBar
    ) {
    //cell rendering in ag-grid
    this.components = {
      buttonRenderer: ActionCheckBox,
    }

    //if no rows , this message will display
    this.overlayNoRowsTemplate = this.constants.Norows;
    this.validation_messages = this.errormessages.selectFilterPopup;
    this.formValid = new FormGroup({
      filter: new FormControl("", []),
      visualType:new FormControl({ value: '', disabled: true }, []),
      selectVisual:new FormControl("", []),
      userReportName:new FormControl("", [this.validation.restrictAllSpecialCharactersExceptHyphenAndUnderscore, Validators.maxLength(100)])
    });
    this.formValid.get('visualType').disable();
    if(this.data.showVisualDropDowns){
      this.formValid.get("selectVisual").setValidators([Validators.required])
      if(this.selectedVisualId){
        this.formValid.get("selectVisual").setValue(this.selectedVisualId)
      }
    }
  }
  noCompareFunction(){ return 0;}
  ngOnInit() {
   this.datasetColummnData =JSON.parse(this.data.columnsData);
   console.log(this.datasetColummnData);
   console.log(this.data.datasetData);
   console.log("**************************************");
   console.log(this.data.showVisualDropDowns);
  // this.selectedFiltersList = this.data.userSpecificFilter || [];
   console.log("After Update: ",this.selectedFiltersList);
   if(this.data.showVisualDropDowns){
    this.showVisualDropDowns=this.data.showVisualDropDowns
   }else{
    this.showVisualDropDowns=false;
   }
   if(this.data.hideReportName){
    this.hideReportName=this.data.hideReportName
   }else{
    this.hideReportName=false
   }
   if(this.data.isChecked){
    this.isChecked=this.data.isChecked;
   }
   else{
    this.isChecked=false;
   }
  //  if(this.data.isResetChecked){
  //   this.isResetChecked=this.data.isResetChecked;
  //  }
  //  else{
  //   this.isResetChecked=false;
  //  }
   let modifiedDate=moment(this.data.datasetData.datasetRefreshDateTime).format('YYYY/MM/DD, HH:mm')
   this.datasetLastRefreshedDate = modifiedDate
   
   
    this.getFiltersList()
    
    this.columnDefs = [
      {
        headerName: 'Select',
        headerTooltip: 'Select',
        tooltipValueGetter: (params) => 'Select/Unselect',
        field: 'chckBox',
        filter: false,
        checkboxSelection: true,
        cellRendererParams: { refresh: this.selectAll.bind(this), },
        width: 120
      },
      { headerName: 'Filter Name', headerTooltip: 'Filter Name', tooltipValueGetter: (params) => 'Filter Name : ' + params.value, field: 'filtername', filter: 'agTextColumnFilter', width: 250 },
      { headerName: 'Filter Description', headerTooltip: 'Filter Description', tooltipValueGetter: (params) => 'Filter Description : ' + params.value, field: 'filterDescription', filter: 'agTextColumnFilter', width: 250 },
    //  { headerName: 'DataSet', headerTooltip: 'DataSet', tooltipValueGetter: (params) => 'DataSet : ' + params.value, field: 'datasetname', filter: 'agTextColumnFilter', width: 250 },
      { headerName: 'Filters', headerTooltip: 'Filters', tooltipValueGetter: (params) => 'Filters : ' + params.value, field: 'filters', filter: 'agTextColumnFilter', width: 250 },
      { headerName: 'Status', headerTooltip: 'Status', tooltipValueGetter: (params) => 'Status : ' + params.value, field: 'status', filter: 'agTextColumnFilter', width: 250 }
    ]
    // if the record has status==no , row color will change
    this.rowClassRules = {
      'rowBackgroundColor': function (params) {
        var numSickDays = params.node.data.status;
        return numSickDays === "No" || numSickDays === null;
      },
    };

    // below object is resizable, sorting and filter for ag-grid
    this.defaultColDef = {
filterParams: {
        maxNumConditions: 2,
        numAlwaysVisibleConditions: 2,
        defaultJoinOperator: 'OR'
      },
      sortable: true,
      resizable: true,
      filter: true
    };

    this.rowSelection = this.constants.rowselection;
    this.paginationPageSize = this.constants.pagesize;
    this.paginationNumberFormatter = function (params) {
      return params.value.toLocaleString();
    };

    this.backgroundColorButton = this.localStorageSettings.getSettings("ColorA");

    console.log(this.backgroundColorButton);
  
  }

  //pagination code
  onPaginationChanged() {
    if (this.gridAPI) {
      this.lastPage = this.gridAPI.paginationIsLastPageFound();
      this.currentPage = this.gridAPI.paginationGetCurrentPage() + 1
      this.nextPage = this.gridAPI.paginationGetCurrentPage() + 1 + 1
      this.nextPagePlusOne = this.gridAPI.paginationGetCurrentPage() + 1 + 1 + 1
      this.totalPages = this.gridAPI.paginationGetTotalPages()
    }
  }

  //this function is for going to the given page number 
  onSearchChange(searchValue: number) {
    this.gridAPI.paginationGoToPage(searchValue - 1);
  }

  // below function is for changing the no of rows per page
  onPageSizeChanged() {
    var value = this.pageSize;
    this.gridAPI.setGridOption('paginationPageSize', Number(value));
  }

  // below function is for going to next page
  onBtNext() {
    console.log("next")
    this.gridAPI.paginationGoToNextPage();
  }

  // below function for going to previous page
  onBtPrevious() {
    console.log("previous")
    this.gridAPI.paginationGoToPreviousPage();
  }

  // below function for going to first page
  onBtFirst() {
    this.gridAPI.paginationGoToFirstPage();
  }

  // below function for going to last page
  onBtLast() {
    this.gridAPI.paginationGoToLastPage();
  }
  //pagination code ends

  async getFiltersList(){
    console.log(this.data);
    console.log("selectedFiltersArray on open:", this.data.selectedFiltersArray);
    
    this.getdata = await this.reportService.retrieveFiltermanagebyDataSetid(this.data.dataSetId);
    console.log(this.getdata)
     this.getdata = (this.getdata || []).filter(item => {

    const status = (item.status || '').toString().toLowerCase();
    const isDeletedFlag = item.isDeleted === true || item.deleted === true || item.isActive === false;
    return status !== 'no' && !isDeletedFlag;
  });
    if(this.data.selectedFiltersArray){
      this.isExternalFilter=false
      if(this.data.selectedFiltersArray.length > 0){
        this.getdata= this.getdata.filter(item => this.data.selectedFiltersArray.includes(item.filtermanageId));
        for(let i=0;i<this.getdata.length;i++){
          this.getdata[i]["isDisable"]=false
           /*Modified by Renuka
            * Fixed first filter duplication when editing records with multiple filters by pushing each individual filter ID instead of repeatedly pushing only the first filter ID from the array.
            */
           this.selectedFilter.push(this.getdata[i].filtermanageId)
        }
      }else{
        for(let i=0;i<this.getdata.length;i++){
          this.getdata[i]["isDisable"]=false
        }
      }
     
    }else{
    for(let i=0;i<this.getdata.length;i++){
      this.getdata[i]["isDisable"]=false
      if(this.data.selectedFiltersArray && this.data.selectedFiltersArray.length > 0){
        this.isExternalFilter=false
        for(let j=0;j<this.data.selectedFiltersArray.length;j++){
          if(this.getdata[i].filtermanageId == this.data.selectedFiltersArray[j]){
            this.selectedFilter.push(this.getdata[i].filtermanageId)
          }
        }

      }else{
        if(this.getdata[i].defaultFilter == "Yes" && this.getdata[i].status == "Yes"){
          if(this.getdata[i].isExternalFile == "Yes"){
            this.isExternalFilter=true
          }else{
            this.isExternalFilter=false
            this.selectedFilter.push(this.getdata[i].filtermanageId)
          }
          
        }else{
          if(i == this.getdata.length-1 &&  this.selectedFilter.length == 0){
            if(this.getdata.length > 1 && this.getdata[0].status == "Yes"){
              console.log(this.getdata[i]);
              this.selectedFilter.push(this.getdata[0].filtermanageId)
            }
          
          }
        }
      }
    }
    }
    this.onSelectionChanged(this.selectedFilter);
    console.log(this.selectedFilter);
    this.getVisuals();
    // 
    // this.gridAPI.setGridOption('rowData', this.getdata);
    // if (this.data.dataSetId == "") {
    //   this.gridAPI.setGridOption('rowData', this.getdata);
    //   this.gridAPI.hideOverlay();
    // }
    // else {
    //   console.log(this.getdata);
    //   this.gridAPI.setGridOption('rowData', this.getdata);
    // }
  }


  // below function is to load the ag grid
  async onGridReady(params) {
    let res: any
    this.gridAPI = params.api;
    this.gridColumnAPI = params.columnApi;
    console.log(this.constants.ReportCreation)
    console.log(this.constants.UserColoumns)
    console.log(this.constants.userid)
    console.log(this.data.dataSetId)
    this.getdata = await this.reportService.retrieveFiltermanagebyDataSetid(this.data.dataSetId);
    // for (let i = 0; i < this.getdata.length; i++) {
    //   this.fieldslist = JSON.parse(this.getdata[i].fieldslist);
    //   //console.log(this.fieldslist["fieldListKeyName"]);
    //   this.getdata[i].fieldslist = this.fieldslist;
    // }
    console.log(this.getdata)
    this.gridAPI.setGridOption('rowData', this.getdata);
    if (this.data.dataSetId == "") {
      this.gridAPI.setGridOption('rowData', this.getdata);
      this.gridAPI.hideOverlay();
    }
    else {
      console.log(this.getdata);
      this.gridAPI.setGridOption('rowData', this.getdata);
      // this.gridAPI.forEachNode(node => {
      //   console.log("node data" + JSON.stringify(node.data))
      //   if (this.data.ObjectId == node.data.objectid) {
      //     node.setSelected(true);
      //   }
      // })
    }
  }

  selectAll(e) {
    console.log(e)
    let d = {
      "userid": e.rowData.userid,
      "objectid": e.rowData.objectid,
      "datasetname": e.rowData.datasetname,
      "accesstype": e.rowData.accesstype,
      "fieldslist": e.rowData.fieldslist,
    }
    this.reportData = d
    console.log(this.reportData)
  }

  closePopup() {
    this.dialogref.close(null)
  }

  senddata(data: any) {
    console.log(data);
    console.log("***************************");
    this.dialogref.close(data);
  }
  onSelectionChanged= async (event) =>{
   
    console.log(event);
    this.selected = event.value;
    console.log("selected dropdown length: ",this.selected);
    console.log(this.selectedFilter);
    this.formValid = new FormGroup({
      filter: new FormControl("", []),
      visualType:new FormControl({ value: '', disabled: true }, []),
      selectVisual:new FormControl("",[]),
      userReportName:new FormControl("",[this.validation.restrictAllSpecialCharactersExceptHyphenAndUnderscore, Validators.maxLength(100)])
    });
    this.formValid.get("filter").setValue(this.selectedFilter)
    this.formValid.get("visualType").disable()
    this.formValid.get("visualType").setValue(this.visualType)
    this.formValid.get("userReportName").setValue(this.userReportName)
    if(this.data.showVisualDropDowns){
      this.formValid.get("selectVisual").setValidators([Validators.required])
      if(this.selectedVisualId){
        this.formValid.get("selectVisual").setValue(this.selectedVisualId)
      }
    }
    
    this.selectedMultipleRowData=[];
    this.selectedFiltersList=[];
    if(this.selectedFilter.length == 0){
      this.selectedExternalFilterS3Path=""
          this.isExternalFilter=false;
          this.selectedFilterManageId=""
          for(let k =0;k<this.getdata.length;k++){
            this.getdata[k].isDisable=false;
          }
    }
    for(let i=0;i<this.selectedFilter.length;i++){
      console.log(this.selectedFilter[i]);
      for(let j=0;j<this.getdata.length;j++){
        if(this.getdata[j].filtermanageId == this.selectedFilter[i]){
          if(this.getdata[j].isExternalFile == "Yes"){
            this.selectedFilter=[]
            this.selectedFilter.push(this.getdata[j].filtermanageId)
            console.log(this.getdata[j]);
            this.selectedExternalFilterS3Path=this.getdata[j].s3Path
            this.isExternalFilter=true;
            this.selectedFilterManageId=this.getdata[j].filtermanageId;
            for(let k =0;k<this.getdata.length;k++){
              if(this.getdata[k].filtermanageId == this.getdata[j].filtermanageId){
                this.getdata[k].isDisable=false;
              }else{
                this.getdata[k].isDisable=true;
              }
            }
            this.selectedFiltersList=[]
            break;
        }else{
          this.selectedExternalFilterS3Path="";
          this.isExternalFilter=false;
          this.selectedFilterManageId="";
        this.selectedMultipleRowData.push(this.getdata[j])
        let filter = JSON.parse(this.getdata[j].filters)
        for(let k =0;k<filter.length;k++){
          filter[k]["multiSelectVaules"]=[]
          filter[k]["manageFilterId"]=this.getdata[j].filtermanageId;
          for(let l=0;l<this.datasetColummnData.length;l++){
            if(filter[k].whereKey == this.datasetColummnData[l].name){

                filter[k]["type"]=this.datasetColummnData[l].type;
                console.log(filter[k].label +"********"+filter[k].whereValue);
              if(this.datasetColummnData[l].type == "DateTime" || this.datasetColummnData[l].type == "Date"){
                if(filter[k].whereValue != "'undefined'" && filter[k].whereValue.length > 0){
                filter[k].whereValue = this.formatDateValue(filter[k].whereValue)
                if(filter[k].whereCondition == "BETWEEN"){
                  filter[k].whereValue1 = this.formatDateValue(filter[k].whereValue1)
                }
                }
              }
            }
          }
          this.selectedFiltersList.push(filter[k])
        }
      }
        }
      }
    }
   this.oldFiltersList=structuredClone(this.selectedFiltersList);
    this.userId=this.localStorageSettings.getSettings('UserId');
    // Added condition to fetch and assign filter values for multiple selected filters instead of only the first filter in the array.
    for(let id of this.selectedFilter){
      const response = await this.getUserSpecificFilters(this.userId, id);

    if (response !== false) {
      this.currentfilterValues = JSON.parse(response);
    
      this.selectedFiltersList.forEach(filter => {
        if (filter.manageFilterId == id) {
        const match = this.currentfilterValues.find(f =>
          f.whereKey === filter.whereKey &&
          f.label === filter.label 
        );
    
        if (match) {          
          filter.whereConditionValue = match.whereConditionValue;

          // Integer value 0 was treated as falsy in condition check, preventing correct restoration of cleared values.
          if (match.whereValue !== null && match.whereValue !== undefined && match.whereValue !== "'undefined'")
             {
            filter.whereValue = match.whereValue;
          }
           if (match.whereValue1 !== null && match.whereValue1 !== undefined && match.whereValue1 !== "'undefined'")
             {
            filter.whereValue1 = match.whereValue1;
          }
        }
      }
        console.log("Final filter after assigning currentfilterValues:", filter);
      });
    }
  }
 //   this.selectedFiltersList = [...this.selectedFiltersList];
    this.selectedFiltersList = JSON.parse(JSON.stringify(this.selectedFiltersList));


    console.log(this.selectedMultipleRowData);
    console.log(JSON.stringify(this.selectedFiltersList));
    
    console.log(this.selectedFiltersList);
    console.log('Final selectedFiltersList:', this.selectedFiltersList.map(f => f.label));

    this.createFormValidationForSelectedFilters();
    console.log(this.uniqueData);
  }
 
  // removeDuplicatesByWhereKey() {
  //   const seen = new Set();
  //   this.uniqueData = this.selectedFiltersList.filter(item => {
  //     if (!seen.has(item.whereKey) && item.whereValue) {
  //       seen.add(item.whereKey);
  //       return true;
  //     }
  //     return false;
  //   });
  // }

  removeDuplicatesByWhereKey() {
    const seen = new Set();
    this.uniqueData = this.selectedFiltersList.filter(item => {
      const isCalculatedField = item.whereCondition === "CalculatedField" || item.whereCondition === "CalculatedFieldWithFilter" || item.whereCondition === "CalculatedFieldForReports"||item.whereCondition === "count"; // Check if the condition is "CalculatedField"
    
      // If it's a CalculatedField, include it without checking for uniqueness
      if (isCalculatedField) {
          return true;
      }
  
      // Otherwise, apply the original logic for uniqueness and other checks
      const shouldInclude = (!seen.has(item.whereKey) && item.whereValue) || 
                            ((item.excludeNull || item.showOnlyNulls) && !item.whereValue);
  
      if (shouldInclude) {
          seen.add(item.whereKey); // Only add to 'seen' if it's not a CalculatedField
          return true;
      }
      return false;
  });
}
  createFormValidationForSelectedFilters(){
    
    for(let i=0;i<this.selectedFiltersList.length;i++){
      const labelValue = this.selectedFiltersList[i]?.label ?? ''; // Avoid undefined
      this.formValid.addControl("label"+i,new FormControl({value: labelValue, disabled: true}, []))
      this.formValid.addControl("condition"+i,new FormControl({value: this.selectedFiltersList[i].whereCondition, disabled: false}, []))
      if( this.removeSingleQuotes(this.selectedFiltersList[i].whereValue) == "undefined"){
        this.formValid.addControl("value"+i,new FormControl({value:"",disabled:false}, []))
        this.selectedFiltersList[i].whereValue="";
      }else{
        this.formValid.addControl("value"+i,new FormControl({value: this.selectedFiltersList[i].whereValue}, []))
        this.selectedFiltersList[i].whereValue=this.checkValue(this.selectedFiltersList[i].whereValue);
      }
      if(this.selectedFiltersList[i].whereCondition == "BETWEEN"){
        if( this.removeSingleQuotes(this.selectedFiltersList[i].whereValue1) == "undefined"){
          this.formValid.addControl("value1"+i,new FormControl({value:"",disabled:false}, []))
          this.selectedFiltersList[i].whereValue1="";
        }else{
          this.formValid.addControl("value1"+i,new FormControl({value: this.selectedFiltersList[i].whereValue1}, []))
          this.selectedFiltersList[i].whereValue1=this.checkValue(this.selectedFiltersList[i].whereValue1);
        }
      }
      if(this.selectedFiltersList[i].whereCondition == "IN"||this.selectedFiltersList[i].whereCondition == "NOT IN"){
        let objectName = this.selectedFiltersList[i].objectWhere + "_" + this.selectedFiltersList[i].whereKey.replace(".", "_");
        this.getMultiSelectDropDownValues(objectName,i)
        this.selectedFiltersList[i].whereValue=this.convertMultiselectValue(this.selectedFiltersList[i].whereValue);
      }

      // 
    }
   console.log(this.selectedFiltersList)
  }
  onSelectionChanged2(event) {
    console.log(event);
    console.log(this.getdata);
   
    for(let i=0;i<this.getdata.length;i++){
      if(this.getdata[i].filtermanageId == this.selectedFilter){
        this.selectedRowData = this.getdata[i];
        break;
      }
    }
    this.selectedFiltersList = JSON.parse(this.selectedRowData.filters);
    // var selectedRows = this.gridAPI.getSelectedRows();
    console.log(this.selectedFiltersList);
    for(let i=0;i<this.selectedFiltersList.length;i++){
      this.formValid.addControl("label"+i,new FormControl({value: this.selectedFiltersList[i].label, disabled: false}, []))
      this.formValid.addControl("condition"+i,new FormControl({value: this.selectedFiltersList[i].whereCondition, disabled: true}, []))
      if( this.removeSingleQuotes(this.selectedFiltersList[i].whereValue) == "undefined"){
        this.formValid.addControl("value"+i,new FormControl({value:"",disabled:false}, []))
        this.selectedFiltersList[i].whereValue="";
      }else{
        this.formValid.addControl("value"+i,new FormControl({value: this.selectedFiltersList[i].whereValue}, []))
        this.selectedFiltersList[i].whereValue=this.checkValue(this.selectedFiltersList[i].whereValue);
      }
      if(this.selectedFiltersList[i].whereCondition == "BETWEEN"){
        if( this.removeSingleQuotes(this.selectedFiltersList[i].whereValue1) == "undefined"){
          this.formValid.addControl("value1"+i,new FormControl({value:"",disabled:false}, []))
          this.selectedFiltersList[i].whereValue1="";
        }else{
          this.formValid.addControl("value1"+i,new FormControl({value: this.selectedFiltersList[i].whereValue1}, []))
          this.selectedFiltersList[i].whereValue1=this.checkValue(this.selectedFiltersList[i].whereValue1);
        }
      }
      if(this.selectedFiltersList[i].whereCondition == "IN"){
        let objectName = this.selectedFiltersList[i].objectWhere + "_" + this.selectedFiltersList[i].whereKey.replace(".", "_");
        
       
        this.getMultiSelectDropDownValues(objectName,i)
        this.selectedFiltersList[i].whereValue=this.convertMultiselectValue(this.selectedFiltersList[i].whereValue);
      }

      // 
    }
    
  }
  getMultiSelectDropDownValues(objectName,index){
    this.spinner.start()
    this.service.retrieveMultiselect(this.localStorageSettings.getSettings("vaultDnsname"), this.data.objectGroup, objectName).subscribe(response => {
      console.log(response);
      if ( response != null && !response.error ) {

        var sampleData= response;
        if(sampleData){
        // var data = sampleData[0].split(",");
        var data = JSON.parse(sampleData[0]);
        
        this.selectedFiltersList[index].multiSelectVaules=[]
        for (let elementIndex = 0; elementIndex < data.length; elementIndex++) {
          let element = data[elementIndex];
          // if (element.includes("[")) {
          //   element = element.replace("[", "");
          // }
          // if (element.includes("]")) {
          //   element = element.replace("]", "");
          // }
          // if (element.includes("\"")) {
          //   element = element.replace("\"", "");
          //   element = element.replace("\"", "");
          // }
          let dataTemplate = { "alias": "" };
          dataTemplate.alias = element;
          // this.multiSelectVaules.push(dataTemplate);
          this.selectedFiltersList[index].multiSelectVaules.push(dataTemplate);
        }
        console.log(this.selectedFiltersList);
        if(this.selectedFiltersList[index].multiSelectVaules){
          this.selectedFiltersList[index].multiSelectVaules=this.selectedFiltersList[index].multiSelectVaules.sort((a, b) => a.alias.localeCompare(b.alias));
        }
        this.spinner.stop();
      }
      } else {
        this.spinner.stop();
        this.snackbar.open("No Facet declared for selected attribute", "OK", { duration: 5000 });
      }
    });
  }
  convertMultiselectValue(whereValue) {
  if (Array.isArray(whereValue)) {
    return whereValue;
  }
  if (!whereValue || typeof whereValue !== 'string') {
    return [];
  }
    let modifiedString;
    if (whereValue.startsWith('(') && whereValue.endsWith(')')) {
      modifiedString = whereValue.slice(1, -1);
    } else {
      modifiedString = whereValue;
    }
    // Split by comma, then remove single quotes and trim spaces
    let result = modifiedString.split(',').map(item => item.trim().replace(/'/g, ''));
    if(result.length == 1 && result[0].length == 0){
      return [];
    }
    
    return result;
  } 
  convertArrayToMultiselectValue(arr) {
    if (!Array.isArray(arr) || arr.length === 0) {
      return arr;
    }
  
    const formatted = arr.map(item => `'${item}'`).join(',');
    return `(${formatted})`;
  }
  removeSingleQuotes(str){
  if (str === null || str === undefined) {
    return "";
  }
  if (Array.isArray(str)) {
    return str;
  }
  if (typeof str !== "string") {
    return str;
  }
    return str.replace(/['%]/g, "");
  }

  checkValue(str){
    if (str === null || str === undefined) {
      return "";
    }
    if (Array.isArray(str)) {
    return str;
    }
    if (typeof str !== "string") {
      return str;
    }
    let value = str.replace(/['%]/g, "");
    if(value == "undefined"){
      return "";
    }else{
      return value;
    }
  }
  res: any;
  filtermanageId:any;
  userId:any;
  filterValues = [];
  filterValuesJson: string = '';
  ids: string[] = [];
  filterResponse:any;
  currentfilterValues=[];
  
  sendDataAndClose = async () => {
const selectedIds = (this.selectedFilter || []).map(String);
const missingSelection: string[] = [];
const missingValue: string[] = [];

const isEmpty = (v: any) =>
  v === null || v === undefined ||
  (Array.isArray(v) && v.length === 0) ||
  (typeof v === 'string' && this.removeSingleQuotes(v).trim() === '');

(this.getdata || []).forEach(parent => {
  const parentId = String(parent.filtermanageId);
 /* Modified by Renuka
  * Date: 2026-03-09
  * Skip validation if filter is not selected */
  if (!selectedIds.includes(parentId)) {
    return;
  }

  let children: any[] = [];
  try { children = JSON.parse(parent.filters || '[]'); } catch {}
  
  children.filter(c => c?.mandatoryFilter).forEach(c => {
    const parentName = parent.filtername || `Filter-${parentId}`;
    const childName = c.label || c.whereKeyAlias || c.whereKey || 'Unnamed';

    const uiChild = (this.selectedFiltersList || []).find(sf =>
      String(sf.manageFilterId) === parentId &&
      (sf.whereKey === c.whereKey || sf.label === c.label)
    ) || c;

    const { whereValue: val, whereValue1: val1, whereCondition: cond = c.whereConditionValue || '' } = uiChild;

    if ((cond === 'BETWEEN' && (isEmpty(val) || isEmpty(val1))) || isEmpty(val)) {
      missingValue.push(`${parentName} [${childName}]`);
    }
  });


if (missingSelection.length) {
  this.formValid.get('filter')?.setErrors({
    required: true,
    message: `Please select mandatory filters: ${missingSelection.join(', ')}`
  });
  this.formValid.get('filter')?.markAsTouched();
  return;
}
 if (missingValue.length) {
    this.selectedFiltersList.forEach((filter, i) => {
      if (!filter.mandatoryFilter) return; 

      const control = this.formValid.get("value" + i);
      const control1 = this.formValid.get("value1" + i);

      if (filter.whereCondition === "BETWEEN") {
        if (isEmpty(filter.whereValue)) {
          control?.setErrors({ required: true });
          control?.markAsTouched();
        }
        if (isEmpty(filter.whereValue1)) {
          control1?.setErrors({ required: true });
          control1?.markAsTouched();
        }
      } else {
        if (isEmpty(filter.whereValue)) {
          control?.setErrors({ required: true });
          control?.markAsTouched();
        }
      }
    });

    return;
  }
});

    if (!this.formValid.valid) {
      for(let i=0;i<this.selectedFiltersList.length;i++){
        if(this.selectedFiltersList[i].whereCondition == "BETWEEN"){
          this.validation.getvalidationmessage();
          this.formValid.get("value"+i).markAsTouched();
          this.formValid.get("value1"+i).markAsTouched();
        }
      }
      this.formValid.get("selectVisual").markAsTouched();
    }else{
   if (this.isChecked) {

      for(let i=0;i<this.selectedFiltersList.length;i++){
        this.selectedFiltersList[i].originalCondition=this.getOperatorNameByValue(this.selectedFiltersList[i].whereCondition);
        this.selectedFiltersList[i].originalValue=this.selectedFiltersList[i].whereValue

        if(this.selectedFiltersList[i].whereConditionValue === "IN"||this.selectedFiltersList[i].whereConditionValue === "NOT IN"){
          if (Array.isArray(this.selectedFiltersList[i].whereValue)) {
            this.selectedFiltersList[i].originalValue = this.selectedFiltersList[i].whereValue.join(', ');
          }
        }


        if(this.selectedFiltersList[i].type == "DateTime" || this.selectedFiltersList[i].type == "Date"){
          if(moment(this.selectedFiltersList[i].whereValue).format('YYYY-MM-DD') != 'Invalid date'){
            this.selectedFiltersList[i].whereValue=moment(this.selectedFiltersList[i].whereValue).format('YYYY-MM-DD');
          }
          console.log(this.selectedFiltersList[i].whereValue);
          if(this.selectedFiltersList[i].whereConditionValue == "BETWEEN"){
            if(moment(this.selectedFiltersList[i].whereValue1).format('YYYY-MM-DD') != 'Invalid date'){
              this.selectedFiltersList[i].whereValue1=moment(this.selectedFiltersList[i].whereValue1).format('YYYY-MM-DD');
            }
            
            console.log(this.selectedFiltersList[i].whereValue1);
          }
          this.selectedFiltersList[i].originalValue =this.selectedFiltersList[i].whereValue +" and "+this.selectedFiltersList[i].whereValue1


        }
        if (
          ('excludeNull' in this.selectedFiltersList[i] && this.selectedFiltersList[i].excludeNull === true) ||
          ('showOnlyNulls' in this.selectedFiltersList[i] && this.selectedFiltersList[i].showOnlyNulls === true)
        ) {
          this.selectedFiltersList[i].originalCondition =
            this.selectedFiltersList[i].excludeNull === true ? "Exclude Null" : "Show Only Null";
          this.selectedFiltersList[i].originalValue = true;
        
        }

///////compare both of them on the UI, just send the values whatever we have 
        this.ids.push(this.selectedFiltersList[i].manageFilterId.toString());
        if(!this.selectedFiltersList[i].hideInVisuals && this.selectedFiltersList[i].whereConditionValue!="IN"){
          
        this.userSpecificFilterData.label=this.selectedFiltersList[i].label;
        this.userSpecificFilterData.whereValue=this.selectedFiltersList[i].whereValue;
        this.userSpecificFilterData.whereConditionValue=this.selectedFiltersList[i].whereConditionValue;
        this.userSpecificFilterData.whereKey=this.selectedFiltersList[i].whereKey;
        this.userSpecificFilterData.whereValue1=this.selectedFiltersList[i].whereValue1;
        this.filterValues.push(structuredClone(this.userSpecificFilterData));
        }

        else if(!this.selectedFiltersList[i].hideInVisuals && this.selectedFiltersList[i].whereConditionValue==="IN"){
          this.userSpecificFilterData.label=this.selectedFiltersList[i].label;
          console.log("where value: ",this.selectedFiltersList[i].whereValue);
          this.userSpecificFilterData.whereValue=this.convertArrayToMultiselectValue(this.selectedFiltersList[i].whereValue);
          this.userSpecificFilterData.whereConditionValue=this.selectedFiltersList[i].whereConditionValue;
          this.userSpecificFilterData.whereKey=this.selectedFiltersList[i].whereKey;
          this.userSpecificFilterData.whereValue1=this.selectedFiltersList[i].whereValue1;
          this.filterValues.push(structuredClone(this.userSpecificFilterData)); 
        }

      }
     // selectedfilterslist is default value
     // u need to figure out where we are getting original json from
     // check if already exists
   //  this.oldFiltersList=this.filterValues;
     this.userId=this.localStorageSettings.getSettings('UserId');
      this.filterValuesJson = JSON.stringify(this.filterValues);
      // Added condition for the multiple filters
      for (let id of this.selectedFilter) {
      const response = await this.getUserSpecificFilters(this.userId,id);
     // this.currentfilterValues=JSON.parse(response);
    //  this.spinner.start();
     if(response!=false){
      const payload = {
        userId: this.userId,
        filtermanageId: id,
        filterValues: this.filterValuesJson
      };
    
      this.dropdownService.insertUserSpecificFilter(payload).subscribe(data=>{
        this.res = data;
        console.log('Got data:', this.res);
        if (this.res.error == true) {
    
          this.snackBar.open(this.res.statusMessage, "OK", { duration: 5000 });
    
          return null;
    
        }
        else {
    
          return data;
    
        }
        
      });
      console.log( this.selectedFiltersList);
    }
    else{
      const payload = {
        filtermanageId: id,
        filterValues: this.filterValuesJson
      };
    
      this.dropdownService.insertUserSpecificFilter(payload).subscribe(data=>{
        this.res = data;
        console.log('Got data:', this.res);
      });
    }
  }
      this.removeDuplicatesByWhereKey()
      console.log(this.uniqueData);
      for(let i=0;i<this.uniqueData.length;i++){

        if(typeof this.uniqueData[i].whereValue === 'string' && this.uniqueData[i].whereCondition != "Space Separated" && this.uniqueData[i].whereCondition != "CalculatedField" && this.uniqueData[i].whereCondition != "CalculatedFieldWithFilter" && this.uniqueData[i].whereCondition != "CalculatedFieldForReports"){
          if (this.uniqueData[i].whereValue.includes(',') && this.uniqueData[i].whereCondition !=="count") {
            this.uniqueData[i].whereValue= this.uniqueData[i].whereValue.split(',').map(item => item.trim());
            if(this.uniqueData[i].whereConditionValue == 'Contains (Exclude)'){
                this.uniqueData[i].whereCondition="NOT IN";
                this.uniqueData[i].whereConditionValue="NOT IN";
            }else{
               this.uniqueData[i].whereCondition="IN";
            this.uniqueData[i].whereConditionValue="IN"
            }
          } 
          if(this.uniqueData[i].whereCondition ==="count"){
            this.uniqueData[i].whereValue=""
          }
        }
        if(this.uniqueData[i].whereCondition == "Space Separated"){
          this.uniqueData[i].whereValue= this.uniqueData[i].whereValue.trim().split(' ').map(item => item.trim());
            if(this.uniqueData[i].whereConditionValue == 'Contains (Exclude)'){
                this.uniqueData[i].whereCondition="NOT IN";
                this.uniqueData[i].whereConditionValue="NOT IN";
            }else{
               this.uniqueData[i].whereCondition="IN";
            this.uniqueData[i].whereConditionValue="IN"
            }
        }
                if(this.uniqueData[i].whereCondition == "Space Separated (Exclude)"){
          this.uniqueData[i].whereValue= this.uniqueData[i].whereValue.trim().split(' ').map(item => item.trim());
            this.uniqueData[i].whereCondition="NOT IN";
            this.uniqueData[i].whereConditionValue="NOT IN"
        }
        if((this.uniqueData[i].whereCondition === "IN" ||this.uniqueData[i].whereCondition === "NOT IN") && this.uniqueData[i].whereValue.length === 0){
          this.uniqueData.splice(i, 1);
          i--;  
        }
      }
      let selectedFiltersListString = JSON.stringify(this.uniqueData);
      let visualId = 0
      if(this.selectedVisualId){
        visualId=this.selectedVisualId
      }else{
        visualId=0
      }
      let visualType = "Tabular"
      if(this.visualType){
        visualType=this.visualType
      }else{
        visualType = "Tabular"
      }
      let reportNameDetails=""
      if(this.userReportName.trim()){
        reportNameDetails=this.userReportName.trim()
      }else{
        reportNameDetails=""
      }
      let resultData={
        selectedFiltersListString:JSON.stringify(this.uniqueData),
        visualType:visualType,
        visualId:visualId,
        reportName:reportNameDetails
      }
      //this.selectedRowData.filters=selectedFiltersListString;
      
      console.log(resultData);
      this.senddata(resultData)
    }
    else{
      for(let i=0;i<this.selectedFiltersList.length;i++){
        this.selectedFiltersList[i].originalCondition=this.getOperatorNameByValue(this.selectedFiltersList[i].whereCondition);
        this.selectedFiltersList[i].originalValue=this.selectedFiltersList[i].whereValue

        if(this.selectedFiltersList[i].whereConditionValue === "IN" ||this.selectedFiltersList[i].whereConditionValue === "NOT IN"){
          if (Array.isArray(this.selectedFiltersList[i].whereValue)) {
            this.selectedFiltersList[i].originalValue = this.selectedFiltersList[i].whereValue.join(', ');
          }
        }


        if(this.selectedFiltersList[i].type == "DateTime" || this.selectedFiltersList[i].type == "Date"){
          if(moment(this.selectedFiltersList[i].whereValue).format('YYYY-MM-DD') != 'Invalid date'){
            this.selectedFiltersList[i].whereValue=moment(this.selectedFiltersList[i].whereValue).format('YYYY-MM-DD');
          }
          console.log(this.selectedFiltersList[i].whereValue);
          if(this.selectedFiltersList[i].whereConditionValue == "BETWEEN"){
            if(moment(this.selectedFiltersList[i].whereValue1).format('YYYY-MM-DD') != 'Invalid date'){
              this.selectedFiltersList[i].whereValue1=moment(this.selectedFiltersList[i].whereValue1).format('YYYY-MM-DD');
            }
            
            console.log(this.selectedFiltersList[i].whereValue1);
          }
          this.selectedFiltersList[i].originalValue =this.selectedFiltersList[i].whereValue +" and "+this.selectedFiltersList[i].whereValue1


        }
        if (
          ('excludeNull' in this.selectedFiltersList[i] && this.selectedFiltersList[i].excludeNull === true) ||
          ('showOnlyNulls' in this.selectedFiltersList[i] && this.selectedFiltersList[i].showOnlyNulls === true)
        ) {
          this.selectedFiltersList[i].originalCondition =
            this.selectedFiltersList[i].excludeNull === true ? "Exclude Null" : "Show Only Null";
          this.selectedFiltersList[i].originalValue = true;
        
        }
           
      }
      this.removeDuplicatesByWhereKey()
      console.log(this.uniqueData);
      for(let i=0;i<this.uniqueData.length;i++){

        if(typeof this.uniqueData[i].whereValue === 'string' && this.uniqueData[i].whereCondition != "Space Separated" && this.uniqueData[i].whereCondition != "CalculatedField" && this.uniqueData[i].whereCondition != "CalculatedFieldWithFilter" && this.uniqueData[i].whereCondition != "CalculatedFieldForReports"){
          if (this.uniqueData[i].whereValue.includes(',') && this.uniqueData[i].whereCondition !=="count") {
            this.uniqueData[i].whereValue= this.uniqueData[i].whereValue.split(',').map(item => item.trim());
            if(this.uniqueData[i].whereConditionValue == 'Contains (Exclude)'){
                this.uniqueData[i].whereCondition="NOT IN";
                this.uniqueData[i].whereConditionValue="NOT IN";
            }else{
               this.uniqueData[i].whereCondition="IN";
            this.uniqueData[i].whereConditionValue="IN"
            }
          } 
          if(this.uniqueData[i].whereCondition ==="count"){
            this.uniqueData[i].whereValue=""
          }
        }
        if(this.uniqueData[i].whereCondition == "Space Separated"){
          this.uniqueData[i].whereValue= this.uniqueData[i].whereValue.trim().split(' ').map(item => item.trim());
            if(this.uniqueData[i].whereConditionValue == 'Contains (Exclude)'){
                this.uniqueData[i].whereCondition="NOT IN";
                this.uniqueData[i].whereConditionValue="NOT IN";
            }else{
               this.uniqueData[i].whereCondition="IN";
            this.uniqueData[i].whereConditionValue="IN"
            }
        }
        if(this.uniqueData[i].whereCondition == "Space Separated (Exclude)"){
          this.uniqueData[i].whereValue= this.uniqueData[i].whereValue.trim().split(' ').map(item => item.trim());
            this.uniqueData[i].whereCondition="NOT IN";
            this.uniqueData[i].whereConditionValue="NOT IN"
        }
        if((this.uniqueData[i].whereCondition === "IN"||this.uniqueData[i].whereCondition === "NOT IN") && this.uniqueData[i].whereValue.length === 0){
          this.uniqueData.splice(i, 1);
          i--;  
        }
      }
      let selectedFiltersListString = JSON.stringify(this.uniqueData);
      let visualId = 0
      if(this.selectedVisualId){
        visualId=this.selectedVisualId
      }else{
        visualId=0
      }
      let visualType = "Tabular"
      if(this.visualType){
        visualType=this.visualType
      }else{
        visualType = "Tabular"
      }
      let reportNameDetails=""
      if(this.userReportName.trim()){
        reportNameDetails=this.userReportName.trim()
      }else{
        reportNameDetails=""
      }
      let resultData={
        selectedFiltersListString:JSON.stringify(this.uniqueData),
        visualType:visualType,
        visualId:visualId,
        reportName:reportNameDetails
      }
      //this.selectedRowData.filters=selectedFiltersListString;
      
      console.log(resultData);
      this.senddata(resultData)
    }
    
  }
}
async getUserSpecificFilters(userId,manageFilterId){

  this.filterResponse = await firstValueFrom(
    this.dropdownService.retrieveUserSpecificFilter(userId,manageFilterId).pipe(
      defaultIfEmpty(null)
    )
  );
  console.log('Now filterResponse is available:', this.filterResponse);
  this.spinner.stop();
  if(!this.filterResponse.error){
    let fValues=this.filterResponse.data;
    return fValues;
  }
  else{
return false;
  }
  
}
onResetClicked(event){
  
  for(let i=0;i<this.selectedFiltersList.length;i++){
    
    if(this.selectedFiltersList[i].label===this.oldFiltersList[i].label && this.selectedFiltersList[i].whereKey===this.oldFiltersList[i].whereKey && this.selectedFiltersList[i].whereConditionValue===this.oldFiltersList[i].whereConditionValue && this.selectedFiltersList[i].whereConditionValue!="IN"){
    this.selectedFiltersList[i].whereValue=this.checkValue(this.oldFiltersList[i].whereValue);
    this.selectedFiltersList[i].whereValue1=this.oldFiltersList[i]?.whereValue1 ? this.checkValue(this.oldFiltersList[i].whereValue1) : '';
    }
    else{
      console.log("where value in reset: ",this.oldFiltersList[i].whereValue);
      if (/^\(.*\)$/.test(this.oldFiltersList[i].whereValue)) {
        this.selectedFiltersList[i].whereValue = this.oldFiltersList[i].whereValue.slice(1, -1);
      
      this.selectedFiltersList[i].whereValue=this.checkValue(this.selectedFiltersList[i].whereValue);
    this.selectedFiltersList[i].whereValue1=this.oldFiltersList[i]?.whereValue1 ? this.checkValue(this.oldFiltersList[i].whereValue1) : '';
      }
      else{
        this.selectedFiltersList[i].whereValue=this.checkValue(this.oldFiltersList[i].whereValue);
    this.selectedFiltersList[i].whereValue1=this.oldFiltersList[i]?.whereValue1 ? this.checkValue(this.oldFiltersList[i].whereValue1) : '';
      }
    }
    }
    console.log(this.selectedFiltersList);
    //this.selectedFiltersList = JSON.parse(JSON.stringify(this.selectedFiltersList));
    console.log("reset applied");
}
  getFormatedDate(event){
    if(moment(event).format('YYYY-MM-DD') != 'Invalid date'){
    
    let formatedDate= moment(event).format('YYYY-MM-DD');
   return formatedDate.length > 0
    }else{
      return false;
    }
  }
  OnConditionChange(event,index){
    console.log(event);
    console.log(index);
    // 
    if(event.value === "Starts with"){
      this.selectedFiltersList[index].whereCondition="STARTS_WITH"
    }else if(event.value === "Ends with"){
      this.selectedFiltersList[index].whereCondition="ENDS_WITH"
    }else if(event.value === "contains"){
      this.selectedFiltersList[index].whereCondition="LIKE"
    }else if(event.value === "Contains (Exclude)"){
      this.selectedFiltersList[index].whereCondition="NOT LIKE"
    }
    else{
      this.selectedFiltersList[index].whereCondition=event.value
    }
    console.log(this.selectedFiltersList);
  
    
  }
  closeFunction(){
    this.closePopup()
  }

  dateFormatForTitle(event){
    return moment(event).format('YYYY/MM/DD')
  }

  formatDateValue(event){
    return moment.utc(event).format('YYYY-MM-DD')
  }

  rmpFilterData(event){
    console.log(event);
    let selectedRows=event;
    let values:any=[];
    let products:any=[];
    if(selectedRows.length >0){
      for(let i=0;i<selectedRows.length;i++){
        console.log(Object.keys(selectedRows[0]));
        if(Object.keys(selectedRows[0]).includes("Risk_ID")){
          values.push(selectedRows[i]["Risk_ID"])
          products.push(selectedRows[i]["3_Product Family"])  
          
        }else if(Object.keys(selectedRows[0]).includes("﻿Risk_ID")){
          values.push(selectedRows[i]["﻿Risk_ID"])
          products.push(selectedRows[i]["3_Product Family"])
        }else{
          values.push(selectedRows[i]["Risk_ID"])
          products.push(selectedRows[i]["3_Product Family"])
        }
        
       
      }
    }
    
    if(values.length > 0){
      let uniqueArray = [...new Set(values)];
      let uniqueArrayProducts = [...new Set(products)];
        let filterObject = [{
          "label": "Risk_ID",
          "whereKey": "Risk_ID",
          "whereLogic": "AND",
          "whereValue": uniqueArray,
          "objectWhere": "Risk_ID",
          "whereValue1": "",
          "whereKeyAlias": "Risk_ID",
          "whereCondition": "IN",
          "whereConditionValue":"IN",
          "multiSelectVaules": [
            
          ],
          "manageFilterId": this.selectedFilterManageId,
          "type": "Object"
        },
        {
          "label": "3_Product Family",
          "whereKey": "3_Product Family",
          "whereLogic": "AND",
          "whereValue": uniqueArrayProducts,
          "objectWhere": "3_Product Family",
          "whereValue1": "",
          "whereKeyAlias": "3_Product Family",
          "whereCondition": "IN",
          "whereConditionValue":"IN",
          "multiSelectVaules": [
            
          ],
          "manageFilterId": this.selectedFilterManageId,
          "type": "Object"
        }
      ]
        let selectedFiltersListString = JSON.stringify(filterObject);
        console.log(selectedFiltersListString);
        this.senddata(selectedFiltersListString)
    }
  }


  searchableDropdown(filters) {
    console.log("&&&&&&&&&&&&&&&&&&&&&&&7");
    console.log(filters);
    
    var columndata = []
    var c = {
      "alias": "Alias",
    }
   columndata.push(c)
    console.log(this.multiSelectVaules)
    console.log(this.multiSelectVaules.length)
   
    // console.log(this.dataSetObject)
    let dialogRef = this.dialog.open(CommonPopupSearchComponent, {
      width: "70%",
      autoFocus: false,
      data: { edata:filters.multiSelectVaules,page:"multiple",columns:columndata,selectedValue:filters.whereValue,selectedPropertyName:"alias"}
    });

    dialogRef.afterClosed().subscribe(result => {
      console.log(result);
      //console.log(value)
      if (result != undefined) {
        console.log(result.selectedRows.map(item => item.alias));
        for(let i=0;i<this.selectedFiltersList.length;i++){
          if(this.selectedFiltersList[i].label == filters.label  && this.selectedFiltersList[i].objectWhere == filters.objectWhere && this.selectedFiltersList[i].type == filters.type && this.selectedFiltersList[i].whereCondition == filters.whereCondition && this.selectedFiltersList[i].whereConditionValue == filters.whereConditionValue && this.selectedFiltersList[i].whereKey == filters.whereKey && this.selectedFiltersList[i].whereKeyAlias == filters.whereKeyAlias && this.selectedFiltersList[i].whereLogic == filters.whereLogic && this.selectedFiltersList[i].whereValue == filters.whereValue && this.selectedFiltersList[i].whereValue1 == filters.whereValue1){
            this.selectedFiltersList[i].whereValue = result.selectedRows.map(item => item.alias)
          }
        }
      //  this.whereData.multiSelect=result.selectedRows.map(item => item.alias);
      // this.whereData.multiSelect= [{key:"value"},{key:"value2"}]
      }
    });

  }

  searchableSingleSelectForAtributies(filters){
    var columndata = []
    var c = {
      "alias": "Alias",
    }
   columndata.push(c)
   console.log(this.datasetColummnData);
   console.log(filters);
   
   let columns =this.datasetColummnData
   let newObject={
    "alias":"None"
  }
  columns.unshift(newObject);
    let dialogRef = this.dialog.open(CommonPopupSearchComponent, {
      width: "70%",
      autoFocus: false,
      data: { edata:columns,page:"single",columns:columndata,selectedValue:[filters.whereValue],selectedPropertyName:"alias"}
    });

    dialogRef.afterClosed().subscribe(result => {
      console.log(result);
      //console.log(value)
      if (result != undefined) {
        for(let i=0;i<this.selectedFiltersList.length;i++){
          if(this.selectedFiltersList[i].label == filters.label  && this.selectedFiltersList[i].objectWhere == filters.objectWhere && this.selectedFiltersList[i].type == filters.type && this.selectedFiltersList[i].whereCondition == filters.whereCondition && this.selectedFiltersList[i].whereConditionValue == filters.whereConditionValue && this.selectedFiltersList[i].whereKey == filters.whereKey && this.selectedFiltersList[i].whereKeyAlias == filters.whereKeyAlias && this.selectedFiltersList[i].whereLogic == filters.whereLogic && this.selectedFiltersList[i].whereValue == filters.whereValue && this.selectedFiltersList[i].whereValue1 == filters.whereValue1){
            console.log(result.selectedRows.map(item => item.alias));
            
            this.selectedFiltersList[i].whereValue = result.selectedRows.map(item => item.alias)[0]
          }
        }
      }
    });

  }
  onVisualTypeSelectionChanged(event){
    console.log(event);
    if(this.visualType == "Pivot" && this.data.datasetData.visualConfig == null){
      this.snackbar.open("Pivot configurations are not specified", "OK", { duration: 5000 });
      this.visualType="Tabular"
      this.formValid.get("visualType").setValue("Tabular")
    }
  }

  getVisuals(){
    this.spinner.start();
    this.visualServices.retreiveManageVisualsDataOnDatasetId(this.data.dataSetId).subscribe(response=>{
      if (response.error == true) {
        this.spinner.stop();
        this.snackbar.open(response.statusMessage, "OK", {
          duration: 5000,
        });
      } else {
        console.log(response);
        let visualList:any=response
        this.visualData=visualList.filter(visual=>visual.status=="Yes");
        this.spinner.stop();
        
      }
    })
  }

  onVisualSelectionChanged(event){
    console.log(event);
    let visualType = this.visualData.filter(item=>item.visualId == event.value)
    if(visualType){
      this.visualType=visualType[0].visualType
     }else{
      this.visualType="Tabular"
     }
     console.log(this.selectedVisualId);
  }
  getOperatorNameByValue(value) {
    const match = this.conditionalOperatorDataWhere.find(item => item.value === value);
    return match ? match.name : value;
  }
  
}
